export class GenericDialogParams {
  title: string = "";
  message: string = "";
  confirmText: string = "";
  type: string = "";
  hasIcon: boolean = false;
  cancelText: string = "";
  onConfirm: (() => void) | undefined;
  onCancel: (() => void) | undefined;
  autoCloseAfter: number | undefined;
  inputValue: string = "";
  trapFocus: boolean = false;
  inputAttrs: DialogInputAttributes | undefined;
}

class DialogInputAttributes {
  placeholder: string = "";
  maxlength: number | undefined;
  minLength: number | undefined;
  canCancel: boolean = false;
  confirmText: string = "";
}
